<BaseModal
  :model-value="modelValue"
  class="edit-quantity-sheet"
  :width="'100%'"
  :bottom-sheet-on-mobile="true"
  @update:model-value="$emit('update:modelValue', $event)"
>
  <template #header>{{ $t('messages.checkout.cart.select_quantity') || 'SELECT QUANTITY' }}</template>

  <div v-if="currentItem" class="edit-quantity-body">
    <ul class="quantity-list">
      <li
        v-for="n in quantityOptions"
        :key="n"
        class="quantity-item"
        :class="{ 'is-selected': selectedQty === n }"
        @click="selectQuantity(n)"
      >
        {{ n }}
      </li>
    </ul>
  </div>
</BaseModal>
